
import bildWaermepumpe from '@/assets/icons/stromverbraucher_waermepumpe.svg';
import bildEmobil from '@/assets/icons/stromverbraucher_eauto.svg';
import bildSonstige from '@/assets/icons/stromverbraucher_sonstige.svg';
import bildKeine from '@/assets/icons/stromverbraucher_keine.svg';
import bildUnknown from '@/assets/icons/unbekannt.svg';

export const powerConsumers = [
    { name: 'Wärmepumpe', available: true, value: 'waermepumpe', api: '20249', image: bildWaermepumpe, single: false },
    { name: 'E-Auto', available: true, value: 'emobil', api: '20250', image: bildEmobil, single: false },
    { name: 'Sonstige', available: true,  value: 'sonstige', api: '20251', image: bildSonstige, single: false },
    { name: 'Keine', available: true,  value: 'keine', api: '22457', image: bildKeine, single: true },
    { name: 'Weiß nicht', available: true,  value: 'unknown', api: '20252', image: bildUnknown, single: true },
];

export const powerConsumersApi = {parameter: '17497', type: 'value_multiplechoices'}

